import { type ReactElement } from 'react';
import { DashboardMemberView } from '@utmb/types/index';
import styles from './loyalty-preview-container.module.scss';
import { LoyaltyPreview } from '../loyalty-preview/LoyaltyPreview';

import { Image } from '@utmb/design-system/image/Image';
import { CloudinaryTransformEnum } from '@utmb/types/cloudinary-transform.enum';
import { pIdToCloudinary } from '@utmb/utils/cloudinary';
import { IconsEnum } from '@utmb/types/icons';
import { Icon } from '@utmb/design-system/icons/Icon';

export interface LoyaltyPreviewContainerProps {
    dashboardMember: DashboardMemberView;
}

export function LoyaltyPreviewContainer({ dashboardMember }: LoyaltyPreviewContainerProps): ReactElement | null {
    return (
        <div className={styles.loyaltyPreviewContainer}>
            <div className={styles.wrapPreview}>
                <LoyaltyPreview dashboardMember={dashboardMember} />
            </div>
            <div className={styles.wrapImage}>
                <Image
                    className={styles.image}
                    objectFit="cover"
                    image={pIdToCloudinary('/worldseries/MYUTMB+/placeholder-1.png', 'Placeholder background')}
                    addOptions={[CloudinaryTransformEnum.TRIM]}
                    maxWidth={1920}
                    objectPosition={'top'}
                />
                <div className={styles.paternTop}>
                    <Icon variant={IconsEnum.NINEPLUS} width={225} height={100} />
                </div>
                <div className={styles.paternBottom}>
                    <Icon variant={IconsEnum.NINEPLUS} width={225} height={100} />
                </div>
            </div>
        </div>
    );
}
